import { getContext } from 'svelte';
/** --------------------- */
export const key = {};
export const globalStyles = (themeObserver) => {
    const globalStylesLight = `<style\tid="svelteui-inject" type="text\/css">body{background-color:white;color:black;}<\/style>`;
    const globalStylesDark = `<style\tid="svelteui-inject" type="text\/css">body{background-color:#1A1B1E;color:#C1C2C5;}<\/style>`;
    if (themeObserver === 'light')
        return globalStylesLight;
    return globalStylesDark;
};
export function useSvelteUIThemeContext() {
    return getContext(key);
}
export function useSvelteUIDefaultProps(component, defaultProps, props) {
    const contextProps = useSvelteUIThemeContext().defaultProps?.[component];
    return { ...defaultProps, ...contextProps, ...props };
}
